import { EnvironmentId } from '@/react/portainer/environments/types';

export const queryKeys = {
  base: () => ['scoped-kubeconfigs'] as const,
  all: () => [...queryKeys.base(), 'all'] as const,
  environment: (environmentId: EnvironmentId) =>
    [...queryKeys.base(), 'environment', environmentId] as const,
};
